import {showToast} from "../toast";

export const Method = {
  GET: `GET`,
  POST: `POST`,
};

const SuccessHTTPStatusRange = {
  MIN: 200,
  MAX: 299,
};

const Url = {
  START: `/site/timer-start`,
  STOP: `/site/timer-stop`,
  VIEW: `/site/timer-view`,
  ADD_TIMER: `/timer/create?id=`,
  ADD_PLAN_TIMER: `/timer/create-evaluation?id=`,
  REMOVE_TIMER: `/timer/delete?id=`,
  REMOVE_PLAN_TIMER: `/timer/delete-evaluation?id=`,
  UPDATE_TIMER: `/timer/update?id=`,
  UPDATE_PLAN_TIMER: `/timer/update-evaluation?id=`,
  UPDATE_DEADLINE: `/task/edit-deadline`,
  UPDATE_PRIORITY: `/task/edit-priority`,
  USER_TIMERS: `/task/get-task-admin-timer`,
};

const TestUrl = {
  START: `/data/timer.json`,
  STOP: `/data/timer-stop.json`,
  VIEW: `/data/timer.json`,
  ADD_TIMER: `/data/timer-update.json?id=`,
  ADD_PLAN_TIMER: `/data/timer-update.json?id=`,
  REMOVE_TIMER: `/data/timer-update.json?id=`,
  REMOVE_PLAN_TIMER: `/data/timer-update.json?id=`,
  UPDATE_TIMER: `/data/timer-update.json?id=`,
  UPDATE_PLAN_TIMER: `/data/timer-update.json?id=`,
  UPDATE_DEADLINE: `/data/deadline.json`,
  UPDATE_PRIORITY: `/data/priority.json`,
  USER_TIMERS: `/data/user-timers.json`,
};

interface LoadOptionsInterface {
  url: string;
  method?: string;
  headers?: Record<string, string>;
  query?;
}

interface CustomQueryOptionsInterface {
  method?: string;
  headers?: Record<string, string>;
  query?;
}

export class Api {
  constructor() {}

  startTimer(taskId) {
    return this._load({
      url: Url.START,
      method: Method.POST,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      query: `taskId=${taskId}`,
    }).then(Api.toJSON);
  }

  stopTimer() {
    return this._load({
      url: Url.STOP,
      method: Method.POST,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then(Api.toJSON);
  }

  viewTimer() {
    return this._load({
      url: Url.VIEW,
      method: Method.POST,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    }).then(Api.toJSON);
  }

  addTimer(formData, taskId) {
    return this._load({
      url: `${Url.ADD_TIMER}${taskId}`,
      method: Method.POST,
      query: formData,
    }).then(Api.toJSON);
  }

  addPlanTimer(formData, taskId) {
    return this._load({
      url: `${Url.ADD_PLAN_TIMER}${taskId}`,
      method: Method.POST,
      query: formData,
    }).then(Api.toJSON);
  }

  removeTimer(timerId) {
    return this._load({
      url: `${Url.REMOVE_TIMER}${timerId}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  removePlanTimer(timerId) {
    return this._load({
      url: `${Url.REMOVE_PLAN_TIMER}${timerId}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  updateTimer(formData, timerId) {
    return this._load({
      url: `${Url.UPDATE_TIMER}${timerId}`,
      method: Method.POST,
      query: formData,
    }).then(Api.toJSON);
  }

  updatePlanTimer(formData, timerId) {
    return this._load({
      url: `${Url.UPDATE_PLAN_TIMER}${timerId}`,
      method: Method.POST,
      query: formData,
    }).then(Api.toJSON);
  }

  getUserTimers() {
    return this._load({
      url: Url.USER_TIMERS,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  updateDeadline(id, date) {
    return this._load({
      url: `${Url.UPDATE_DEADLINE}?id=${id}&date=${date ? date : null}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  updatePriority(id, priority) {
    return this._load({
      url: `${Url.UPDATE_PRIORITY}?id=${id}&priority=${priority}`,
      method: Method.GET,
    }).then(Api.toJSON);
  }

  customQuery(url: string, {method = Method.GET, query, headers}: CustomQueryOptionsInterface) {
    const options: CustomQueryOptionsInterface & {url: string} = {
      url,
      method,
    }

    if (query) {
      options.query = query;
    }

    if (headers) {
      options.headers = headers;
    }

    return this._load(options).then(Api.toJSON);
  }

  _load({url, query, method, headers}: LoadOptionsInterface) {
    const options: RequestInit = {
      method,
      mode: `cors`,
    };

    if (headers) {
      options.headers = headers;
    }

    if (query) {
      options.body = query && method === Method.POST ? query : null;
    }

    return fetch(url, options).then(Api.checkStatus).catch(Api.catchError);
  }

  static checkStatus(response) {
    try {
      if (response.status < SuccessHTTPStatusRange.MIN || response.status > SuccessHTTPStatusRange.MAX) {
        // console.error(`${response.status}: ${response.statusText}`);
        // return `error`;
        throw new Error(`${response.status}: ${response.statusText}, url: ${response.url}`);
      }
    } catch (e) {
      // @ts-ignore
      if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
        // @ts-ignore
        window.sendError.sendMessage(e);
      }
    }

    return response;
  }

  static toJSON(response) {
    if (response === `error`) {
      return response;
    }
    return response.json();
  }

  static catchError(err) {
    showToast(`Ошибка отправки запроса`);
    // @ts-ignore
    if (window.sendError && !window.location.host.includes(`localhost`) && !window.location.href.includes(`taskroom22v.d-idei.ru/`)) {
      // @ts-ignore
      window.sendError.sendMessage(err);
    }
    throw err;
  }
}
